import React from 'react'
// import { ReactComponent as Logo } from "../assets/logo/beta/miraj-logo.svg"
// import { ReactComponent as Icon } from "../assets/logo/beta/miraj-arrow.svg"
import { ReactComponent as Logo } from "../assets/logo/miraj-logo.svg"
import { ReactComponent as Icon } from "../assets/logo/miraj-arrow.svg"

interface IProps {
    isIcon?: boolean
}

export default function ApplicationLogo(props: IProps) {

    const { isIcon } = props

    if (isIcon){
        return <Icon />
    }

    return <Logo />
}
